import { useMutation } from '@apollo/client';
import {
  ReviewDeliverables,
  ReviewDeliverablesVariables,
} from 'api/campaignV2/types/ReviewDeliverables';
import { REVIEW_DELIVERABLES } from 'api/campaignV2/mutations';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useReviewDeliverables = () => {
  const [reviewDeliverables] = useMutation<
    ReviewDeliverables,
    ReviewDeliverablesVariables
  >(REVIEW_DELIVERABLES);

  return {
    reviewDeliverables,
  };
};
